__turbopack_context__.v({
  "smallCell": "m8hb0G_smallCell",
});
